import { render, staticRenderFns } from "./dynamic-natural-language-form.vue?vue&type=template&id=5ee36d50&scoped=true&"
import script from "./dynamic-natural-language-form.vue?vue&type=script&lang=js&"
export * from "./dynamic-natural-language-form.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-natural-language-form.vue?vue&type=style&index=0&id=5ee36d50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee36d50",
  null
  
)

export default component.exports